/**
 * Recurrence-editor helpers (weekday abbreviations + hour formatting).
 *
 * Kept in this module so the canonical 2-letter weekday set lives next
 * to the rest of the date-time formatters. Tu/Th and Sa/Su are
 * intentionally disambiguated.
 */

/** 2-letter weekday abbreviations that disambiguate Tu/Th and Sa/Su. */
export const DAY_ABBREVS: Record<string, string> = {
  Monday: 'Mo',
  Tuesday: 'Tu',
  Wednesday: 'We',
  Thursday: 'Th',
  Friday: 'Fr',
  Saturday: 'Sa',
  Sunday: 'Su',
};

/** Format a 24h hour value (0–23) as a 12h AM/PM string ("12 AM", "1 PM"). */
export function formatHour(hour: number): string {
  if (hour === 0) return '12 AM';
  if (hour === 12) return '12 PM';
  return hour < 12 ? `${hour} AM` : `${hour - 12} PM`;
}
